import React, { useEffect, useState } from 'react'
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi'

import { client } from '../../client'
import { AppWrap, MotionWrap } from '../../wrapper'
import './Experiences.scss'

const Experiences = () => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [experiences, setExperiences] = useState([])
  const [swipeDirection, setSwipeDirection] = useState(null)
  const [startX, setStartX] = useState(null)

  useEffect(() => {
    const query = '*[_type == "experiences"] | order(_updatedAt asc)'

    client.fetch(query).then(data => setExperiences(data))
  }, [])

  /* swipe behavior handlers */
  const handleTouchStart = e => {
    setStartX(e.touches[0].clientX)
  }
  const handleTouchMove = e => {
    const currentX = e.touches[0].clientX
    const diff = startX - currentX

    if (diff > 0) setSwipeDirection('left')
    else if (diff < 0) setSwipeDirection('right')
  }
  const handleTouchEnd = () => {
    setSwipeDirection(null)
    setStartX(null)

    if (swipeDirection === 'left')
      setCurrentIndex(
        currentIndex === experiences.length - 1 ? 0 : currentIndex + 1,
      )
    else if (swipeDirection === 'right')
      setCurrentIndex(
        currentIndex === 0 ? experiences.length - 1 : currentIndex - 1,
      )
  }

  return (
    <>
      <h2 className="head-text">
        Working <span>experiences</span>
      </h2>
      {experiences.length !== 0 && (
        <div>
          <div className="app__flex">
            <div
              className="app__experiences-btn"
              onClick={() =>
                setCurrentIndex(
                  currentIndex === 0
                    ? experiences.length - 1
                    : currentIndex - 1,
                )
              }>
              <HiChevronLeft />
            </div>
            <div
              className="app__experiences-item"
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}>
              <div className="app__experiences-content">
                {/* date & location */}
                <p className="bold-text date">
                  {experiences[currentIndex].dateAndLocation.date}
                </p>
                <p>
                  {experiences[currentIndex].dateAndLocation.totalMonth} (mos)
                </p>
                <h5 className="p-text location">
                  {experiences[currentIndex].dateAndLocation.location}
                </h5>
              </div>
              {/* what you do */}
              <div className="app__experiences-content">
                <h4>{experiences[currentIndex].whatYouDo.companyName}</h4>
                <p className="p-text bold-text">
                  {experiences[currentIndex].whatYouDo.position}
                </p>
                <h5 className="bold-text">
                  {experiences[currentIndex].whatYouDo.majorNote}
                </h5>
                <h6 className="p-text">
                  {experiences[currentIndex].whatYouDo.minorNote}
                </h6>
              </div>
              {/* skill evaluation */}
              <div className="app__experiences-content">
                <h5 className="p-text">
                  {experiences[currentIndex].additionalInfo.description}
                </h5>
                <h4 className="bold-text">
                  Company size:
                  {experiences[currentIndex].additionalInfo.companySize}
                </h4>
                <p className="p-text">
                  Biggest team size:
                  {experiences[currentIndex].additionalInfo.teamSize}
                </p>
              </div>
            </div>

            <div
              className="app__experiences-btn"
              onClick={() =>
                setCurrentIndex(
                  currentIndex === experiences.length - 1
                    ? 0
                    : currentIndex + 1,
                )
              }>
              <HiChevronRight />
            </div>
          </div>
          <div className="app__experiences-btn-mb">
            <div
              className="app__experiences-btn"
              onClick={() =>
                setCurrentIndex(
                  currentIndex === 0
                    ? experiences.length - 1
                    : currentIndex - 1,
                )
              }>
              <HiChevronLeft />
            </div>
            <div
              className="app__experiences-btn"
              onClick={() =>
                setCurrentIndex(
                  currentIndex === experiences.length - 1
                    ? 0
                    : currentIndex + 1,
                )
              }>
              <HiChevronRight />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default AppWrap(
  MotionWrap(Experiences, 'app__expriences'),
  'app__whitebg',
)
